import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Paper, createStyles, Box, } from "@mantine/core";
import { CloseX, Error as ErrorIcon, Info as InfoIcon, Success as SuccessIcon, Warn as WarnIcon, } from "../assets/icons.generated";
import { STATUS_COLOR } from "../theme/colors";
const useStyles = createStyles((theme, { borderColor }) => ({
    card: {
        display: "flex",
        gap: "10px",
        ...(borderColor && {
            border: `1px solid ${theme.fn.variant({
                variant: "filled",
                color: borderColor,
            }).background}`,
        }),
    },
    button: {
        padding: "7px",
        lineHeight: 0,
    },
    closeIcon: {
        width: "10px",
        height: "10px",
        minWidth: "10px",
        minHeight: "10px",
        fill: theme.fn.variant({ variant: "filled", color: "black.5" })
            .background,
    },
}));
const Notification = ({ type, close, hasColor, iconSize = 24, children, ...rest }) => {
    const configuration = getConfiguration(type);
    const { classes } = useStyles({
        ...(hasColor && { borderColor: configuration.borderColor }),
    });
    return (_jsxs(Paper, { shadow: hasColor ? undefined : "sm", bg: hasColor ? configuration.backgroundColor : undefined, radius: "sm", p: "md", className: classes.card, ...rest, children: [_jsx(Box, { w: iconSize, h: iconSize, children: configuration.icon }), children, close && (_jsx("button", { className: classes.button, onClick: close, children: _jsx(CloseX, { className: classes.closeIcon }) }))] }));
};
const getConfiguration = (type) => {
    switch (type) {
        case "info":
            return {
                icon: _jsx(InfoIcon, {}),
                backgroundColor: STATUS_COLOR.INFORMATIVE_WASH,
                borderColor: STATUS_COLOR.INFORMATIVE,
            };
        case "success":
            return {
                icon: _jsx(SuccessIcon, {}),
                backgroundColor: STATUS_COLOR.AFFIRMATIVE_WASH,
                borderColor: STATUS_COLOR.AFFIRMATIVE,
            };
        case "error":
            return {
                icon: _jsx(ErrorIcon, {}),
                backgroundColor: STATUS_COLOR.ERROR_WASH,
                borderColor: STATUS_COLOR.ERROR,
            };
        case "warn":
            return {
                icon: _jsx(WarnIcon, {}),
                backgroundColor: STATUS_COLOR.WARNING_WASH,
                borderColor: STATUS_COLOR.WARNING,
            };
    }
};
export default memo(Notification);
